import * as tooltips from "./tooltips";
import React from "react";
import GeoJSONMultiPolygonCollection from "../../../../components/maps/GeoJSONMap/GeoJSONMultiPolygonCollection";

import * as markers from "./markers";


export const microZoneParameterAPIName = {
    'l1_mode': 'l1_mode',
    'l1_max': 'l1_max',
}

const MicroZonesLayer = ({webgis}) => {
    const {layersState, featuresState} = webgis;
    const {layers} = layersState;

    const {
        geoMicroZoneQuery,
        microZonesGeoJSON,
        webgisRegistryQuery
    } = featuresState;

    const registry = webgisRegistryQuery.data ?? {};
    const layerRegistry = registry["microzones"];

    const microZonesUpdatedAt = geoMicroZoneQuery.dataUpdatedAt

    const microZonePolygonKeyFn = (feature) => {
        return `microZonePolygon-${feature.properties?.id}-${layers.microzones.visibleParam}-${microZonesUpdatedAt}`;
    }

    const microZoneColorByFeature = (feature) => {
        const param = layers.microzones.visibleParam;
        const apiParam = microZoneParameterAPIName[param];
        const value = feature.properties?.[apiParam];

        return markers.getColorForValue(value, param, layerRegistry);
    }

    return <GeoJSONMultiPolygonCollection featureCollection={microZonesGeoJSON}
                                          polygonKeyFn={microZonePolygonKeyFn}
                                          renderFeatureTooltip={tooltips.renderMicrozoneTooltip}
                                          colorByFeature={microZoneColorByFeature}/>
}

export default MicroZonesLayer;